// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"3676e981","587":"d3ef5497"}[chunkId] + ".chunk.js";
};